import { jsx, jsxs } from 'react/jsx-runtime';
import { useContext, useMemo } from 'react';
import { useCustomMoney } from '@circlefin/hooks';
import { SkeletonBox } from '../../SkeletonBox/SkeletonBox.es.js';
import { NumberBoxContext } from '../NumberBox.Context/NumberBox.Context.es.js';

const NumberBoxCustomAmount = ({ as: DynamicTag = 'h3', children, decimals, isCryptoCurrency, hideSymbol = false, locale = 'en-US', signDisplay = false, symbol, padded = false })=>{
    const { loading, fallback } = useContext(NumberBoxContext);
    const { customMoney } = useCustomMoney({
        locale
    });
    const amount = useMemo(()=>{
        if (children != null && decimals != null && symbol) {
            return customMoney({
                number: children,
                currencyConfig: {
                    decimals,
                    name: symbol,
                    isCryptoCurrency: isCryptoCurrency
                },
                options: {
                    // We want to display the currency symbol for non cryptocurrencies.
                    symbol: !isCryptoCurrency,
                    padded,
                    signDisplay
                }
            });
        }
        return fallback;
    }, [
        children,
        decimals,
        isCryptoCurrency,
        signDisplay,
        symbol,
        padded,
        fallback,
        customMoney
    ]);
    return jsx(DynamicTag, {
        className: "amount",
        children: jsxs(SkeletonBox, {
            className: "loading",
            loading: loading,
            children: [
                amount,
                !hideSymbol && symbol && children != null && jsx("span", {
                    className: "currency",
                    children: symbol
                })
            ]
        })
    });
};

export { NumberBoxCustomAmount };
//# sourceMappingURL=NumberBox.CustomAmount.es.js.map
